// @flow

import React, { type Node, useCallback } from 'react';
import { useEnrollment } from '../context';
import {
  Container,
  Content,
  CheckmarkIcon,
  Title,
  Subtitle,
  ReturnButton,
} from './success-screen.styles';

export function SuccessScreen(): Node {
  const { data } = useEnrollment();

  const handleReturnToStore = useCallback(() => {
    window.location.href = data.intentUrl;
  }, [data.intentUrl]);

  return (
    <Container>
      <Content>
        <CheckmarkIcon>
          <CheckmarkSvg />
        </CheckmarkIcon>

        <Title>Vínculo realizado com sucesso!</Title>
        <Subtitle>
          Tudo pronto para pagar com sua conta vinculada. Volte à loja e continue sua compra.
        </Subtitle>

        <ReturnButton onClick={handleReturnToStore}>
          Voltar à loja
        </ReturnButton>
      </Content>
    </Container>
  );
}

export function CheckmarkSvg(): Node {
  return (
    <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="40" cy="40" r="38" stroke="#20a83e" strokeWidth="3" fill="none" />
      <path d="M24 40L35 51L56 30" stroke="#20a83e" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" fill="none" />
    </svg>
  );
}
